import { render } from "./DashboardCreate.vue?vue&type=template&id=e8fa0702&scoped=true"
import script from "./DashboardCreate.vue?vue&type=script&lang=js"
export * from "./DashboardCreate.vue?vue&type=script&lang=js"

import "./DashboardCreate.vue?vue&type=style&index=0&id=e8fa0702&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8fa0702"]])

export default __exports__